/**
 * 87. Pivot Report Viewer — not available yet (REP-BUILDERS, D661).
 *
 * No route computes a pivot or creates one: `GET /v1/reporting/pivots` lists
 * `PivotDefinition` rows with `cellCount` a constant 0. The page showed that
 * zero as a figure, offered a "New pivot" with no handler and an "Open" that
 * was a badge. No build slice is planned for it, so the page names the
 * register row instead.
 */
import { NotAvailablePage } from "@/components/NotAvailable";
import { useTranslation } from "@/lib/i18n";

export function PivotReportViewerPage() {
  const { t } = useTranslation();
  return (
    <NotAvailablePage
      title={t("nav.pivotReportViewer")}
      message={t("notAvailable.pivot")}
      reason="unplanned"
      slice="D661"
    />
  );
}
